import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import Layout from "../components/Layout"
import PostList from "../components/PostList"
import { Helmet } from "react-helmet"
import { ThemeProvider } from "../context/ThemeContext"
import SEO from "../components/SEO"

const getPosts = graphql`
  {
    allMdx(sort: { fields: frontmatter___date, order: DESC }) {
      totalCount
      edges {
        node {
          frontmatter {
            title
            slug
            spoiler
            date(formatString: "MMMM Do, YYYY")
            image {
              childImageSharp {
                fluid(quality: 90) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
          timeToRead
        }
      }
    }
    site {
      siteMetadata {
        title
        description
        siteUrl
        image
      }
    }
  }
`

export default () => {
  const response = useStaticQuery(getPosts)
  const posts = response.allMdx.edges
  // const { title, description, image, siteUrl } = useSiteMetadata();
  const { title, description, image, siteUrl } = response.site.siteMetadata
  const customTitle = `${title} | Personal Blog by Naimul Islam Siam`
  // console.log(response);
  return (
    <>
      <SEO
        title={customTitle}
        description={description}
        image={image}
        pathname={siteUrl}
      />
      <Helmet>
        <html lang="en" />
        {/* <script
          async
          src="https://kit.fontawesome.com/3dda85cfa7.js"
          crossorigin="anonymous"
        ></script> */}
        {/* <link rel="preload" as="font" type="font/woff2" href="./../../static/fonts/great-vibes-v7-latin-regular.woff2" crossorigin></link>
        <link rel="preload" as="font" type="font/woff2" href="./../../static/fonts/open-sans-v17-latin-regular.woff2" crossorigin></link>
        <link rel="preload" as="font" type="font/woff2" href="./../../static/fonts/ubuntu-v14-latin-700.woff2" crossorigin></link>
        <link rel="preload" as="font" type="font/woff2" href="./../../static/fonts/fira-mono-v8-latin-regular.woff2" crossorigin></link> */}
      </Helmet>
      <ThemeProvider>
        <Layout>
          <PostList posts={posts} />
        </Layout>
      </ThemeProvider>
    </>
  )
}
